import { createThemeCompiler } from '../../../utils';

export const iconThemeCompiler = createThemeCompiler((semantics) => {
    const { palette, stroke, borderRadius } = semantics;
    return {
        icon: {
            colors: {
                backgroundColor: palette.transparent,
                borderColor: palette.transparent,
                foregroundColor: palette.themePrimary
            },
            composites: {
                borderStyle: 'solid',
                borderWidth: stroke.none,
                borderRadius: borderRadius.sharp
            }
        }
    };
});
